<template>
    <div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="mw-970 mx-auto">
                        <div class="o-booking-footer">
                            <div class="c-section">
                                <div class="bg-white is-rounded py-3 px-4 mb-4">
                                    <strong class="d-block cl-sec-l">All prices quoted do not include access fee to Venice</strong>

                                    <p class="my-2 cl-dark">
                                        Access fee to Venice will be applicable as per Italian legislation Article 1,
                                        paragraph 1129, of Law 145 dated 30.12.2018. We currently do not have information on
                                        how this will be applied. We will contact you via email once we receive further
                                        instructions.
                                    </p>
                                    <p class="mb-0 mt-2 cl-dark">
                                        If once we inform you about the city tax you do not wish to proceed with the booking, you will be allowed to cancel your ticket without any penalties. 
                                    </p>
                                </div>

                                <div class="py-4 px-3 mt-4 bg-sec-light-hover">
                                    <ul class="d-flex flex-column flex-sm-row align-items-center justify-content-around cl-sec-l">
                                        <li>
                                            <button type="button" class="c-link is-rev py-2 d-block" @click="showInfo('terms')">Terms and conditions</button>
                                        </li>
                                        <li>
                                            <button type="button" class="c-link is-rev py-2 d-block" @click="showInfo('supplements')">Luggage and supplements info</button>
                                        </li>
                                        <li>
                                            <button type="button" class="c-link is-rev py-2 d-block" @click="showInfo('cancellation')">Cancellation policy</button>
                                        </li>
                                        <li>
                                            <button type="button" class="c-link is-rev py-2 d-block" @click="showInfo('modification')">Amend a booking</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal :loading="modal.loading" :title="modal.title" :body="modal.body" v-model="modal.show"></modal>
    </div>
</template>

<script>
import Modal from '../components/Modal.vue'
import Loader from '../components/Loader.vue'
export default {
    components: {
        Loader,
        Modal,
    },
    data() {
        return {
            modal: {
                loading: false,
                title: '',
                body: '',
                show: false,
            }
        }
    },
    methods: {
        showInfo(section) {
            this.modal.loading = this.modal.show = true
            this.$api.info({ section: section }).then(response => {
                this.modal.title = response.title
                this.modal.body = response.text
                this.modal.loading = false
            })
        },
    }
}
</script>